import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

export const STYLE_TYPES = ["primary", "secondary", "filterbox"];

export const TYPES = ["submit", "reset", "button", "menu"];

const Button = (props) => {
  const {
    children = "some content",
    className,
    disabled = false,
    href,
    isLink,
    name,
    refParent,
    styleType = "primary",
    type = "button",
    value = "",
    ...rest
  } = props;
  const componentClass = classnames(
    "sal-button",
    `sal-button--${styleType}`,
    className,
    { "sal-button--disabled": disabled },
  );

  const baseProps = {
    className: componentClass,
    ref: refParent ? refParent : null,
    ...rest,
  };

  const linkProps = {
    href,
  };

  const buttonProps = {
    name,
    value,
    type,
    disabled,
  };

  return isLink ? (
    <a {...baseProps} {...linkProps}>
      {children}
    </a>
  ) : (
    <button {...baseProps} {...buttonProps}>
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  isLink: PropTypes.bool,
  name: PropTypes.string.isRequired,
  refParent: PropTypes.func,
  styleType: PropTypes.oneOf(STYLE_TYPES),
  type: PropTypes.oneOf(TYPES),
  value: PropTypes.string,
};

export default Button;
